

function About() {
  return <p className="text-white">this is the about page</p>
}

export default About;
